import { DefaultState } from './reducer';

interface BingoScheduleReducer {
    bingoScheduleReducer: DefaultState;
}

export const selectBingoScheduleGames = ({ bingoScheduleReducer }: BingoScheduleReducer) => bingoScheduleReducer.bingoSchedule;
export const selectIsScheduleLoaded = ({ bingoScheduleReducer }: BingoScheduleReducer) => bingoScheduleReducer.isLoaded;
export const selectPortletSettings = ({ bingoScheduleReducer }: BingoScheduleReducer) => bingoScheduleReducer.portletSettings;
